import React, { Component } from 'react';

import CustomIcon from 'components/common/CustomIcon';

const sidebarModalIcon = {
    project: 'briefcase',
    person: 'user-man'
};

class SidebarModalButton extends Component {
    render() {
        const { modal } = this.props;

        return modal ? (
            <CustomIcon type={sidebarModalIcon[modal.type]} onClick={modal.openModal} />
        ) : null;
    }
}

export default SidebarModalButton;
